<script setup>
import { provide } from 'vue';
defineProps({ destination: { type: Object, required: true } });
// Preview chrome must never publish sections/status or participate in a
// mounted destination's loading handshake.
provide('shopManagementPageStatus', null);
provide('shopManagementPageSections', null);
provide('bayhiveLoadingPresentation', null);
</script>

<template>
  <section
    class="destination-page-skeleton"
    role="status"
    aria-live="polite"
    aria-busy="true"
    :aria-label="`Loading ${destination.title}`"
  >
    <div class="destination-page-skeleton-content" inert aria-hidden="true">
      <component :is="destination.component" v-bind="destination.props" />
    </div>
  </section>
</template>

<style scoped>
.destination-page-skeleton,
.destination-page-skeleton-content {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  min-height: 0;
  min-width: 0;
}
</style>
